import OfficeList from "./OfficeList.vue";
import InspectionReports from "./InspectionReports.vue";
import MailTemplateList from "./MailTemplateList.vue";
import MailAccountList from "./MailAccountList.vue";
import FormList from "./FormList.vue";
import Templates from "./Templates.vue";
import DocumentEdit from "./DocumentEdit.vue";
import RentIncreaseRun from "./RentIncreaseRun.vue";
import RentIncreaseParks from "./RentIncreaseParks.vue";
import Receipts from "./Receipts.vue";

module.exports = [
    {path: '/offices', component: OfficeList, meta: {title: 'Offices'}},
    {path: '/forms', component: FormList, meta: {title: 'Forms'}},
    {path: '/inspection-reports', component: InspectionReports, meta: {title: 'Inspection Reports'}},
    {path: '/rent-increase', component: RentIncreaseRun, meta: {title: 'Monthly rent increase run'}},
    {path: '/rent-increase/parks', component: RentIncreaseParks, meta: {title: 'Manufactured home parks (RTB-11a)'}},
    {path: '/receipts', component: Receipts, meta: {title: 'Receipts from the app'}},
    {path: '/settings/mail-templates', component: MailTemplateList, meta: {title: 'Mail Templates'}},
    {path: '/settings/mail-accounts', component: MailAccountList, meta: {title: 'Mail Accounts'}},
    {path: '/sterling/templates', component: Templates, meta: {title: 'Templates'}},
    {path: '/sterling/document/edit', component: DocumentEdit, meta: {title: 'Document Editor'}},
];